module.exports = __webpack_public_path__ + "img/orange.27a6cab9.png";